import { render, staticRenderFns } from "./MessageBody.vue?vue&type=template&id=41e26298&scoped=true"
import script from "./MessageBody.vue?vue&type=script&lang=js"
export * from "./MessageBody.vue?vue&type=script&lang=js"
import style0 from "./MessageBody.vue?vue&type=style&index=0&id=41e26298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e26298",
  null
  
)

export default component.exports